import React, { Fragment, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AsyncSelect from 'react-select/async';


export const SupplierCreate = (props) => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    /* API Call Post Method */
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    //Customer createset
    const [names, setNames] = useState("");
    const [emails, setEmails] = useState("");
    const [gstno, setGSTNO] = useState("");
    const [contactNumber1s, setContactNumber1s] = useState("");
    const [contactNumber2s, setContactNumber2s] = useState("");
    const [addressline1s, setAddressLine1s] = useState("");
    const [addressline2s, setAddressLine2s] = useState("");
    const [location, setLocation] = useState("");
    const [suppliernote, setSuppliernote] = useState("");
    const [openingbalance, setOpeningbalance] = useState("");

    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");

    const [emailError, setEmailError] = useState('');

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmails(value);

        if (!validateEmail(value)) {
            setEmailError('Please enter a valid email address.');
        } else {
            setEmailError('');
        }
    };

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!names) {
            setErrorMessages("Name are required!");
            setIsLoading(false);
            return;
        }

        if (!contactNumber1s) {
            setErrorMessages("Contact Number are required!");
            setIsLoading(false);
            return;
        }

        if (!addressline1s) {
            setErrorMessages("Address Line 1 are required!");
            setIsLoading(false);
            return;
        }

        try {

            const SupplierCreateData = {
                CompanyId: companyId,
                Name: names,
                ContactNumber1: contactNumber1s,
                ContactNumber2: contactNumber2s,
                GSTNumber: gstno,
                AddressLine1: addressline1s,
                AdressLine2: addressline2s,
                OpeningBalance: openingbalance,
                Location: location,
                Email: emails,
                SupplierRemark: suppliernote,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            postData('SupplierApi', SupplierCreateData, token)
                .then((response) => {
                    console.log('Supplier Created success:', response);
                    setNames("");
                    setContactNumber1s("");
                    setContactNumber2s("");
                    setAddressLine1s("");
                    setAddressLine2s("");
                    setSuppliernote("");
                    setEmails("");
                    setGSTNO("");
                    setLocation("");
                    setOpeningbalance("");

                    setSuccessMessages("Supplier Created successful!");
                    setErrorMessages(""); // Clear error message on success
                    history.push('/SupplierIndex');

                    setTimeout(() => {
                        setSuccessMessages("");
                    }, 3000); // 3 seconds
                })
                .catch((error) => {
                    console.error('Supplier Create error:', error);
                    setIsLoading(false);
                });


        }
        catch (error) {
            console.error('Supplier Create error:', error);
        }
    };

    /* End API */


    return (

        <Fragment>
            <div className="w-full max-w-full md:max-w-sm container mt-6 mx-auto px-4">

                <form onSubmit={submitData}>
                    <div className="w-full mb-2 flex">
                        <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>SUPPLIER CREATE</h6>
                        <Tooltip title="Exit">
                            <Link to="/SupplierIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'brown', fontWeight: 'bolder', marginBottom: '10px' }}>
                                    Back To List <ArrowForwardIosIcon />
                                </Button>
                            </Link>
                        </Tooltip>
                        <Tooltip title="SAVE">
                            <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder', marginLeft: '10px', marginTop: '-10px' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>
                        </Tooltip>

                    </div>
                    {errorMessages && <p className="text-red-500 text-center">{errorMessages}</p>}
                    {successMessages && <p className="text-green-500 text-center">{successMessages}</p>}

                    <div className="w-full mb-2 flex flex-col md:flex-row">

                        <div className="w-full md:w-1/2 mb-2 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="Name">
                                Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={names}
                                onChange={(e) => setNames(e.target.value)}
                                type="text"
                                placeholder="Enter Name"
                            />
                        </div>

                        <div className="w-full md:w-1/4 mb-2 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="contactNumber1">
                                Contact No:1 <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={contactNumber1s}
                                onChange={(e) => {
                                    const input = e.target.value.replace(/\D/g, '');
                                    if (input.length <= 15) {
                                        setContactNumber1s(input);
                                    }
                                }}
                                type="text"
                                placeholder="Contact Number 1"
                            />
                        </div>

                        <div className="w-full md:w-1/4 mb-2 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="contactNumber2">
                                Contact No:2
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={contactNumber2s}
                                onChange={(e) => {
                                    const input = e.target.value.replace(/\D/g, '');
                                    if (input.length <= 15) {
                                        setContactNumber2s(input);
                                    }
                                }}
                                type="text"
                                placeholder="Contact Number 2"
                            />
                        </div>

                        <div className="w-full md:w-1/3 mb-2 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="email">
                                Email
                            </label>
                            {/* <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={emails} onChange={(e) => setEmails(e.target.value)}
                                type="text"
                                placeholder="Email"
                            /> */}

                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={emails}
                                onChange={handleEmailChange}
                                type="text"
                                placeholder="Email"
                            />
                            {emailError && <p className="text-red-500 text-xs mt-1">{emailError}</p>}

                        </div>

                    </div>

                    <div className="w-full mb-2 flex flex-col md:flex-row">
                        <div className="w-full md:w-1/3 mb-2 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="email">
                                GST NO
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={gstno} onChange={(e) => setGSTNO(e.target.value)}
                                type="text"
                                placeholder="GST NO"
                            />
                        </div>
                        <div className="w-full md:w-1/2 mb-2 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="AddressLine1">
                                Address Line 1 <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={addressline1s} onChange={(e) => setAddressLine1s(e.target.value)}
                                type="text"
                                placeholder="Address Line 1"
                                maxLength={100}
                                rows={1}
                            />
                            <p className="text-sm text-blue-700 mt-1 text-right">
                                {addressline1s.length}/100
                            </p>
                        </div>

                        <div className="w-full md:w-1/2 mb-2 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="AddressLine2">
                                Address Line 2
                            </label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={addressline2s} onChange={(e) => setAddressLine2s(e.target.value)}
                                type="text"
                                placeholder="Address Line 2"
                                maxLength={100}
                                rows={1}
                            />
                            <p className="text-sm text-blue-500 mt-1 text-right">
                                {addressline2s.length}/100
                            </p>
                        </div>


                    </div>


                    <div className="w-full mb-2 flex flex-col md:flex-row" style={{ marginTop: '-30px' }}>
                        <div className="w-full md:w-1/3 mb-2 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="Location">
                                Location
                            </label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={location}
                                onChange={(e) => setLocation(e.target.value)}
                                type="text"
                                placeholder="Location"
                                maxLength={100}
                                rows={1}
                            />
                            <p className="text-sm text-green-500 mt-1 text-right">
                                {location.length}/100
                            </p>
                        </div>
                        <div className="w-full md:w-1/3 mb-2 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="openingbalance">
                                Opening Balance
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={openingbalance} onChange={(e) => setOpeningbalance(e.target.value)}
                                type="text"
                                placeholder="Opening Balance"
                                style={{ textAlign: 'right' }}
                                maxLength={10}
                            />
                        </div>
                        <div className="w-full md:w-4/5 mb-2 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="SupplierRemark">
                                Supplier Remark
                            </label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={suppliernote}
                                onChange={(e) => setSuppliernote(e.target.value)}
                                type="text"
                                placeholder="Enter Supplier Remark"
                                maxLength={200}
                                rows={1}
                            />
                            <p className="text-sm text-black-500 mt-1 text-right">
                                {suppliernote.length}/200
                            </p>
                        </div>

                    </div>

                </form>

            </div>
        </Fragment>
    );
}


